import Link from 'next/link';

import { MenuItem } from '@/fo/ui/app/menu/base';
import { utilEventCityModal } from '@/fo/util/event-city-modal';

import { Items } from '../Items/Items';

import { styles } from './FirstScreen.styles';

export interface ContactInfo {
  phone: string;
  hours: string;
  email: string;
}

export interface FirstScreenProps {
  searchInput?: React.ReactNode;
  items: MenuItem[];
  city?: string;
  infoItems?: MenuItem[];
  contactInfo?: ContactInfo;
  onSearchClick?: () => void;
  onMenuItemClick: (items: MenuItem[], index: number, title: string) => void;
}

export function FirstScreen({
  searchInput,
  items,
  city,
  infoItems = [],
  contactInfo,
  onSearchClick,
  onMenuItemClick
}: FirstScreenProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <div
        className={slots.searchContainer()}
        onClick={() => onSearchClick?.()}
      >
        {searchInput}
      </div>

      <div className={slots.categories()}>
        <Items
          items={items}
          props={(item, index) => ({
            onClick: () => onMenuItemClick(items, index, item.label)
          })}
        />
      </div>

      <div className={slots.info()}>
        <div
          className={slots.infoItem()}
          onClick={() => utilEventCityModal.open()}
        >
          {city}
        </div>
        {infoItems.map((item, index) => (
          <Link
            key={index}
            href={item.href}
            className={slots.infoItem()}
          >
            {item.label}
          </Link>
        ))}
      </div>

      {contactInfo && (
        <div className={slots.contact()}>
          <div className={slots.contactDetails()}>
            <a
              href={`tel:${contactInfo.phone}`}
              className={slots.contactPhone()}
            >
              {contactInfo.phone}
            </a>
            <div className={slots.contactHours()}>{contactInfo.hours}</div>
          </div>
          <a
            href={`mailto:${contactInfo.email}`}
            className={slots.contactEmail()}
          >
            {contactInfo.email}
          </a>
        </div>
      )}
    </div>
  );
}
